/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.11.2016
 * Copyright: xdot GmbH 2015
 */


const _config = { paths: {
    'named-props': '/api/jsonws/base.namedprop/list-all/-expand?p_auth=' + Liferay.authToken,
    'group-schemas': '/api/jsonws/base.groupschema/list-group-schemas/group-id/'+Liferay.ThemeDisplay.getScopeGroupId()+'?p_auth=' + Liferay.authToken,
    'initial-named-lists': '/api/jsonws/administration.namedlist/list-viewable-by-group-scope/?p_auth=' + Liferay.authToken
}
};
window[ 'req' + 'uire' ].config(_config);

window[ 'req' + 'uire' ]([
        'base-portlet/js/base-portlet'
    ],
    function () {
        console.info('Initial load of plugins done');
    },
    function (err) {
        console.error('Initial load of plugins: ', err.requireModules, ' fail', err);
        if (!Liferay.ThemeDisplay.isSignedIn()) {
            throw new Error('Not signedIn!');
        }
    }
);



// WEBPACK FOOTER //
// ./js/boot-base-portlet.js